<template>
  <div
    class="nav-item language-select dropdown"
    :class="{ 'language-select_authorized': $store.getters['user/isLoggedIn'] }"
  >
    <button
      id="dropdownMenuButton"
      class="btn btn-language"
      :class="{
        'btn-language_authorized': $store.getters['user/isLoggedIn'],
        'btn-language_open': opened,
      }"
      type="button"
      @click="opened = !opened"
    >
      {{ String($i18n.locale) }}
    </button>
    <div
      class="dropdown-menu"
      :class="{ show: opened }"
      aria-labelledby="dropdownMenuButton"
      @click="opened = !opened"
    >
      <a
        class="dropdown-item px-2 py-0"
        href="#"
        v-for="lang in langs"
        :key="lang.id"
        @click.prevent="
          changeLang(lang.id)
          $emit('changeLang')
        "
        :class="{ selected: lang.id === $i18n.locale }"
        ><span class="dropdown-menu-lng">{{ String(lang.id) }}</span>
        {{ lang.title }}</a
      >
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { changeLang } from '@/utils/funcs'

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    ss: '%s s',
    m: 'a minute',
    mm: '%d m',
    h: 'an hour',
    hh: '%d h',
    d: 'a day',
    dd: '%d d',
    M: 'a month',
    MM: '%d M',
    y: 'a year',
    yy: '%d Y',
  },
})
moment.updateLocale('ru', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'сек',
    ss: '%s сек',
    m: 'мин',
    mm: '%d мин',
    h: 'час',
    hh: '%d ч',
    d: 'день',
    dd: '%d дн',
    M: 'мес',
    MM: '%d мес',
    y: 'год',
    yy: '%d г',
  },
})

export default {
  data() {
    return {
      opened: false,
      langs: [
        { id: 'ru', title: 'Русский' },
        { id: 'en', title: 'English' },
      ],
    }
  },
  methods: {
    changeLang(to) {
      changeLang(to)
    },
  },
  created() {
    // change locale to localstorage locale
    localStorage.removeItem('pn_currentLocale')
    const currentLocale = localStorage.getItem('pn_layout_locale')
    this.changeLang(
      _.isString(currentLocale)
        ? currentLocale
        : process.env.VUE_APP_DEFAULT_LANG || 'ru'
    )
  },
}
</script>

<style lang="scss">
.language-select {
  .btn-language {
    background-color: #333333;
    top: 4px;
    color: #fff;
    font-size: 1rem;
    padding: 0 5px;
    border-radius: 2px;
    line-height: 1.5rem;
    text-transform: capitalize;

    @media (max-width: 1200px) {
      top: -11px;
      bottom: auto;
    }
    @media (max-width: 768px) {
      top: -15px;
      right: 18px;
      left: auto;
    }

    &_authorized {
      position: static;
      @media (max-width: 768px) {
        position: absolute;
        top: 4px;
        right: 18px;
      }
    }

    &:hover {
      color: $primary-color2;
    }
    &_open {
      background: $primary-color2;
      &:hover {
        color: #fff;
      }
    }
  }
  .dropdown-menu {
    background-color: $title-color;
    text-align: right;
    left: auto;
    right: -4px;
    color: #fff;
    @media (max-width: 1200px) {
      top: 20px;
    }

    border-radius: 0;
    min-width: 8rem;
    padding: 12px 8px;
    text-align: start;

    &-lng {
      background: #333333;
      display: inline-block;
      padding: 0px 6px;
      margin-right: 2px;
      line-height: 24px;
      border-radius: 2px;
      text-transform: capitalize;
    }

    .dropdown-item {
      color: #fff;
      padding: 7px 16px 7px 8px !important;

      &:hover {
        color: #fff;
        background-color: $primary-color2;
        border-radius: 2px;
      }
      &.selected {
        font-weight: 600;
      }
    }
  }
  &_authorized {
    order: -1;
    @media (max-width: 768px) {
      position: static;
      order: 0;
    }
    .dropdown-menu {
      top: 30px;
      @media (max-width: 768px) {
        top: 37px;
      }
    }
  }
}
.auth {
  @media (max-width: 610px) {
    z-index: 10;
  }
  .btn-language {
    position: absolute;
    top: 10px;
    left: auto;
    right: 40px;
    background: #e0e0ea;
    color: $title-color;
    &:hover {
      color: $primary-color2;
    }
    @media (max-width: 610px) {
      top: 18px;
      left: auto;
      right: 30px;
    }
    @media (min-width: 610.1px) and (max-width: 768px) {
      left: auto;
    }
  }
  .dropdown-menu {
    top: 32px;
    left: auto;
    right: 38px;
    background: #fff;
    border-radius: 4px;

    @media (max-width: 610px) {
      top: 37px;
      right: 30px;
    }

    &-lng {
      background: #e0e0ea;
      color: $title-color;
    }

    .dropdown-item {
      color: $title-color;
      padding: 7px 16px 7px 8px !important;

      &:hover {
        color: #fff;
        background-color: $primary-color2;
        border-radius: 2px;
      }
    }
  }
}
.without-login {
  .btn-language {
    position: static;
  }
}
</style>
